import gsap from 'gsap';

export const carouselBannersGSAP = (carouselBannersElements: NodeListOf<HTMLElement>) => {
  const DELAY = 5000;

  carouselBannersElements.forEach(carousel => {
    if (!carousel) return;
    const banners = Array.from(carousel.querySelectorAll<HTMLElement>('.carousel-banner'));
    if (banners.length === 0) return;
    let current = 0;
    let isTweening = false;

    // Pokud je pouze jeden banner, zobraz ho a nastav výšku wrapperu
    if (banners.length === 1) {
      banners[0].style.transform = 'none';
      banners[0].style.opacity = '1';
      banners[0].style.position = 'relative';
      banners[0].style.pointerEvents = 'auto';
      setWrapperHeight(carousel, banners[0]);
      return;
    }

    // Nastav výšku wrapperu při načtení
    setWrapperHeight(carousel, banners[current]);

    // Inicializace pozic
    banners.forEach((banner, i) => {
      gsap.set(banner, {
        xPercent: i === 0 ? 0 : 100,
        opacity: 1,
        zIndex: i === 0 ? 2 : 1,
        position: 'absolute',
        top: 0,
        left: 0
      });
      banner.style.pointerEvents = i === 0 ? 'auto' : 'none';
    });

    const gotoSlide = (value: number) => {
      if (isTweening) return;
      isTweening = true;
      const prevBanner = banners[current];
      let nextIndex = current + value;
      if (nextIndex < 0) nextIndex = banners.length - 1;
      if (nextIndex >= banners.length) nextIndex = 0;
      const nextBanner = banners[nextIndex];

      gsap.set(nextBanner, { xPercent: value > 0 ? 100 : -100 });
      gsap.to(prevBanner, {
        xPercent: value > 0 ? -100 : 100,
        duration: 0.6,
        onComplete: () => {
          // Po animaci nastav pointer-events a z-index pouze na aktivní banner
          banners.forEach((banner, i) => {
            if (i === nextIndex) {
              banner.style.zIndex = '2';
              banner.style.pointerEvents = 'auto';
            } else {
              banner.style.zIndex = '1';
              banner.style.pointerEvents = 'none';
            }
          });
          // Po změně banneru nastav výšku wrapperu podle obrázku
          setWrapperHeight(carousel, nextBanner);
          isTweening = false;
        }
      });
      gsap.to(nextBanner, {
        xPercent: 0,
        duration: 0.6
      });
      current = nextIndex;
    };

    // Automatická změna
    let interval = setInterval(() => gotoSlide(1), DELAY);

    // Ovládání šipek
    const arrowLeft = carousel.querySelector<HTMLButtonElement>('[data-carousel-banner-left]');
    const arrowRight = carousel.querySelector<HTMLButtonElement>('[data-carousel-banner-right]');

    const handleArrowClick = (direction: number) => {
      clearInterval(interval);
      gotoSlide(direction);
      interval = setInterval(() => gotoSlide(1), DELAY);
    };

    arrowLeft?.addEventListener('click', () => handleArrowClick(-1));
    arrowRight?.addEventListener('click', () => handleArrowClick(1));
  });
};

// Pomocná funkce pro nastavení výšky wrapperu podle aktivního obrázku (mobil)
const setWrapperHeight = (carousel: HTMLElement, banner: HTMLElement) => {
  const img = banner.querySelector('img');
  if (img && img.complete) {
    carousel.style.height = img.offsetHeight + 'px';
  } else if (img) {
    img.addEventListener('load', () => {
      carousel.style.height = img.offsetHeight + 'px';
    }, { once: true });
  }
};
